/* @generated */

// src/assets/ui-icon/line/file-template.tsx
import * as React from "react";
var FileTemplateLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "m17.341 6.03-1.372-1.37A2.236 2.236 0 0 0 14.38 4H5.5v16H18v-3h-1.5v1.5H15V20h-1.5v-1.5H10V20H8.5v-1.5H7v-13h7V8h2.5v2.5H18V7.621a2.264 2.264 0 0 0-.659-1.59Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement("path", { d: "M16.5 15.5H18V12h-1.5v3.5Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }));
export {
  FileTemplateLine
};
